import React, { useEffect, useState } from "react";
import Breadcrums from "../../../common/breadcrumbs";
import { useTranslation } from "react-i18next";
import * as colorPaletteService from "../../../services/colorPaletteService";
import { useNavigate, useParams } from "react-router-dom";
import { Loader } from "rsuite";
import { capitalizeFirstLetter } from "../../../../../utils/commonfunction";

const ViewColors = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const params = useParams();
    const [dataLoaded, setDataLoaded] = useState(false);
    const [palette, setPalette] = useState({});

    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        {
            title: "Color Palettes",
            url: "/admin/productManagement/colors/list/1",
        },
        { title: "View", url: "" },
    ];

    useEffect(() => {
        colorPaletteService
            .Details(params.id)
            .then((response) => {
                setPalette(response && response.data ? response.data : {});
                setDataLoaded(true);
            })
            .catch((error) => {
                console.error("error=====>", error);
                setDataLoaded(true);
            });
    }, [params.id]);

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            {dataLoaded ? (
                <div className="row row-sm">
                    <div className="col-lg-12 col-md-12 animation_fade">
                        <div className="card custom-card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6 className="main-content-label mb-3">Color Palette Details</h6>
                                </div>

                                <div className="table-responsive">
                                    <table id="simple-table" className="table table-bordered table-hover">
                                        <tbody>
                                            <tr>
                                                <th style={{ width: "20%" }}>Palette Name</th>
                                                <td>{palette.name || "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <th>Status</th>
                                                <td>
                                                    <span className={`badge ${palette.status === 1 ? "bg-success" : "bg-danger"}`}>
                                                        {palette.status === 1 ? "Active" : "Inactive"}
                                                    </span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Palette Colors</th>
                                                <td>
                                                    <div className="d-flex flex-wrap gap-3">
                                                        {palette.colors && palette.colors.length > 0 ? (
                                                            palette.colors.map((color, i) => (
                                                                <div key={i} className="d-flex align-items-center p-2 border rounded bg-light">
                                                                    <div
                                                                        style={{
                                                                            width: "24px",
                                                                            height: "24px",
                                                                            borderRadius: "50%",
                                                                            background: color.gradient || color.hex,
                                                                            border: "1px solid rgba(0,0,0,0.15)",
                                                                            marginRight: "8px"
                                                                        }}
                                                                    />
                                                                    <div>
                                                                        <div className="fw-bold text-dark text-xs">{color.name}</div>
                                                                        <div className="text-muted text-[10px]">{color.hex}</div>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        ) : "No colors defined"}
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="mt-4 d-flex">
                                    <button
                                        className="btn btn-main-primary signbtn mr-2"
                                        onClick={() => navigate(`/admin/productManagement/colors/edit/${palette._id}`)}
                                    >
                                        <i className="ri-pencil-line me-1"></i> Edit Palette
                                    </button>
                                    <button
                                        className="btn ripple btn-dark"
                                        type="button"
                                        onClick={() =>
                                            navigate("/admin/productManagement/colors/list/1")
                                        }
                                    >
                                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                                        {t("btn_back")}
                                    </button>
                                </div>

                             </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="text-center p-5">
                    <Loader size="md" content="Loading..." vertical />
                </div>
            )}
        </>
    );
};

export default ViewColors;
